import { INIT_AUTH } from './../constants/actionTypes'

const authReducer = (store = {}, action) => {
  switch (action.type) {
    case INIT_AUTH:
      return {
        ...store,
        ...action.auth
      }
    default:
      return store
  }
}

export default authReducer
